import Nullstack from 'nullstack';
export default function IconBrandFinder({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-brand-finder",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("rect", {
    x: "3",
    y: "4",
    width: "18",
    height: "16",
    rx: "1"
  }), "   ", Nullstack.element("path", {
    d: "M7 8v1"
  }), "   ", Nullstack.element("path", {
    d: "M17 8v1"
  }), "   ", Nullstack.element("path", {
    d: "M12.5 4c-.654 1.486 -1.26 3.443 -1.5 9h2.5c-.19 2.867 .094 5.024 .5 7"
  }), "   ", Nullstack.element("path", {
    d: "M7 15.5c3.667 2 6.333 2 10 0"
  }), " ");
}